import {RecalcInfo} from './recalcInfo.model'

export class RecipeIngredient {
  Ingredient: RecipeIngredientData;
}

export class RecipeIngredientData {
    Id_Compaund: number;
    Id_Recipe: number;
    Id_Product: number;
    ProductFullName: string;
    Name: string;
    Id_ParentRecipe: number;
    UIndex: number;
    CalculationWeight: number;
    Weight: number;
    IsChangeable: number;
    RecalcName: string;
    RecalcVolume: number;
    StateForChange: number;
    TemporaryIndex = -1;
    AlternativeProduct: any[];
    RecalcWeights: RecalcInfo[];
    Original: OriginalProduct;
    Changed: 0 | 1;
    Id_PlanStageCompaund: number;
}

export class OriginalProduct {
  Id_Product: number;
  Name: string;
  Weight: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/recipe-component-model.ts